module.exports = __webpack_public_path__ + "media/images/flags/gn-fcc7731e31cd3d980b80696dc79796cb.svg";